module.exports = __webpack_public_path__ + "static/outdoor-showers-87327827f13a69ce7374cbfabb1a1aef.jpg";